import React from "react";

import { DefaultFacetDisplayValue } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/DefaultFacet/defaultFacet.container";
import { DefaultFacetValueComponent } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/DefaultFacet/defaultFacetValue.component";

type DefaultFacetComponentProps = {
    values: Array<DefaultFacetDisplayValue>;
    showCount: boolean;
};

const DefaultFacetComponent = ({
    values,
    showCount,
}: DefaultFacetComponentProps) => (
    <ul className={"pl-0 mb-0 list-unstyled"}>
        {values.map(value => (
            <DefaultFacetValueComponent
                key={`${value.label}-${value.refined}`}
                value={value}
                showCount={showCount}
            />
        ))}
    </ul>
);

export { DefaultFacetComponent };
